import { Container } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useNavigate, useSearchParams } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import { Authenticator, ThemeProvider, Theme, useTheme } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { Amplify, Auth } from "aws-amplify";
import { config } from "../../utils/config";
import { signIn } from "../../redux/auth/authSlice";
import Header from "./Header";
import Footer from "./Footer";
import { Box, Button, Grid, List, ListItem, Stack, Typography } from "@mui/material";
import Loginimg from "../../assets/login-img-2.png";
import LoginBackground from "../../assets/login-bg.png";
import Logo from "../../assets/logo-blue.png";
import { signOut as signOutRedux } from "../../redux/auth/authSlice";
import { getApplicationAsync, resetUser } from "../../redux/user/userSlice";
import { Logger } from "aws-amplify";
import { API, getStudentEmail, setNirvToken, setStudentEmail } from "../../utils/http";
Amplify.configure(config.awsConfig);
function PrivateRoutes() {
	const { tokens } = useTheme();
	const navigate = useNavigate();
	const [searchParams, setSearchParams] = useSearchParams();
	const [loading, setLoading] = useState(false);
	useEffect(() => {
		const token = searchParams.get("nirv-token");
		if (token) {
			setLoading(true);
			console.log("Token: ", token);
			//call api and then
			setNirvToken(token);
			API.get(`token/${token}`)
				.then((r) => {
					const res = r.data.payload;
					console.log(res);
					Auth.signIn(res.userName, res.password).then((r) => {
						console.log(r);
						// window.location.reload();
						setNirvToken(token);
						setStudentEmail(res.student.email);
						window.location.href = window.location.origin + "/dashboard";
					});
				})
				.catch((e) => {
					console.log(e);
				});
		}
	}, []);
	const theme = {
		name: "Auth Example Theme",
		tokens: {
			colors: {
				font: {
					interactive: {
						value: "#0054A6",
					},
				},
				brand: {
					primary: {
						10: "#66b5ff",
						80: "#0054A6",
						90: "#0061bc",
						100: "#0061bc",
					},
				},
			},
			components: {
				tabs: {
					item: {
						_focus: {
							color: {
								value: "#0054A6",
							},
						},
						_hover: {
							color: {
								value: "#0054A6",
							},
						},
						_active: {
							color: {
								value: "#0054A6",
							},
						},
					},
				},
			},
		},
	};
	// const handleFederatedLogIn = (e) => {
	// 	e.preventDefault();
	// 	// Auth.federatedSignIn({ customProvider: "nirv-dev" }).catch((e) => {
	// 	// 	console.log("error");
	// 	// 	console.log(e);
	// 	// });
	// 	Auth.signIn("omihai00@gmail.com", "MinicliP2.").then((r) => {
	// 		console.log(r);
	// 		window.location.reload();
	// 	});
	// };
	const components = {
		// SignIn: {
		// 	Footer() {
		// 		return <Button onClick={handleFederatedLogIn}>Sign In With NIRV</Button>;
		// 	},
		// },
		SignUp: {
			Footer() {
				return (
					<Stack paddingX={4} paddingBottom={4}>
						<Typography>Password requirements:</Typography>
						<List dense={true}>
							<ListItem>~ Contains at least 1 number</ListItem>
							<ListItem>~ Contains at least 1 special character</ListItem>
							<ListItem>~ Contains at least 1 uppercase letter</ListItem>
							<ListItem>~ Contains at least 1 lowercase letter</ListItem>
						</List>
					</Stack>
				);
			},
		},
	};
	const dispatch = useDispatch();
	return (
		<Grid
			container
			alignItems="center"
			sx={{ minHeight: { xs: "100vh" }, backgroundimg: `url(${LoginBackground})`, backgroundSize: "cover", backgroundRepeat: "no-repeat" }}
		>
			<Grid item sm={6} xs={12} sx={{ display: { xs: "none", sm: "initial" } }}>
				<img src={Loginimg} width="100%" />
			</Grid>
			<Grid item sm={6} xs={12}>
				<Grid container spacing={2}>
					<Grid item xs={12} textAlign={"center"}>
						<img src={Logo} height="200px" />
					</Grid>
					<Grid item xs={12}>
						<ThemeProvider theme={theme}>
							<Authenticator loginMechanisms={["email"]} components={components}>
								{({ signOut, user }) => {
									return (
										<Content
											signOut={() => {
												signOut();
												dispatch(signOutRedux());
												dispatch(resetUser());
											}}
											user={user}
										/>
									);
								}}
							</Authenticator>
						</ThemeProvider>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
}

function Content({ signOut, user }) {
	const currentEmail = useSelector((state) => state.auth.currentAuthenticatedUser?.email);
	useEffect(() => {
		console.log(user);
		const studentEmail = getStudentEmail();
		console.log(studentEmail);
		if (currentEmail == "nirvsystem@gutenbergcerts.com" && !studentEmail) {
			signOut();
			console.error("You are not authorized to access this page");
			return;
		}
		const r = {
			email: studentEmail ?? user.attributes.email,
			idToken: user.signInUserSession.idToken.jwtToken,
			authorization: user.signInUserSession.accessToken.jwtToken,
		};
		dispatch(signIn(r));
		dispatch(getApplicationAsync()).then((r) => {
			console.log(r);
		});
	}, [user]);
	const dispatch = useDispatch();
	const style = user ? { position: "absolute", top: 0, left: 0, width: "100%", backgroundColor: "white", minHeight: "100vh" } : {};
	return (
		<div style={style}>
			<Navbar currentUser={currentEmail} signOut={signOut} />

			<Container maxWidth="lg">
				<Outlet />
			</Container>
		</div>
	);
}

export default PrivateRoutes;
